define([], function () {
  /**
   * Returns whether landing page open/click tracking should run for this visitor.
   *
   * Respects explicit ?dnt=1 or ?dnt=yes query values (compliance/review URLs).
   * Other dnt values (e.g. dnt=0) do not suppress tracking. Cookie-based opt-out
   * is enforced server-side on tracking endpoints and does not require a
   * separate HTML variant.
   *
   * @returns {boolean} True when open/click tracking should run for this visitor.
   */
  return function shouldTrack() {
    var dnt = new URLSearchParams(window.location.search).get("dnt");
    return dnt !== "1" && dnt !== "yes";
  };
});